import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { BASE_URLS, PLATFORM_TYPE, USERTYPE } from "../../constants/constants";
import { downloadExcel } from "react-export-table-to-excel";
import autoTable from "jspdf-autotable";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export function convertDate(inputFormat) {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/");
}

export function downloadExcelFile(filename,sheetname,headerData,tabledata,showTotal=false,cellColored=false,cellNo){
  // downloadExcel({
  //   fileName: filename,
  //   sheet: sheetname,
  //   tablePayload: {
  //     header: headerData,
  //     body: tabledata,
  //   },
  // });
const workbook = new ExcelJS.Workbook();
const worksheet = workbook.addWorksheet('Sheet1');
worksheet.mergeCells(1, 1, 1, headerData.length);
const headingRow = worksheet.getRow(1);
const headingCell = headingRow.getCell(1);
headingCell.value = filename;
headingCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2E75B5' } };
headingCell.font = { bold: true, color: { argb: 'FFFFFF' } };
headingCell.alignment = { horizontal: 'center' };
const headersRow = worksheet.addRow(headerData);
tabledata.forEach(data => {
  const dataValues = Object.values(data);
  worksheet.addRow(dataValues);
});
if(cellColored){
  worksheet.eachRow((row,rowNumber)=>{
    if (row.values?.[cellNo] === 'No') {
      const pendingCell = row.getCell(cellNo)
      // row.eachCell((cell, colNumber) => {
      //   // Apply styling to cell
      //   console.log("hi")
      //   pendingCell.fill = {
      //     type: 'pattern',
      //     pattern: 'solid',
      //     fgColor: { argb: 'FFFF00' }, // Yellow color
      //   };
      // });
      pendingCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' }, // Yellow color
      };
    }
  })
}

const headingRow1 = worksheet.getRow(1+1+tabledata.length);
if(showTotal){
  for (let index = 1; index <= headingRow1._cells.length; index++) {
    const headingCell1 = headingRow1.getCell(index)
    headingCell1.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2E75B5' } };
    headingCell1.font = { bold: true, color: { argb: 'FFFFFF' } };
    headingCell1.alignment = { horizontal: 'center' };
    
  }
}
// console.log(headingCell1)
// Save the workbook as an XLSX file
workbook.xlsx.writeBuffer()
  .then(buffer => {
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, filename+'.xlsx');
  })
  .catch(err => {
    console.error('Error exporting Excel file:', err);
  });
}

export function downloadPdfForMultipleTable(filename,headerData,tableData){
  const doc = new jsPDF()
  var marginY = 20;
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  tableData?.map((item,i)=>{
    let lastY=doc.lastAutoTable.finalY
    if(lastY){
      doc.text(20,doc.lastAutoTable.finalY+10,item.heading)
      autoTable(doc, {
        head: [item.header],
        font: "helvetica",
        tableWidth: "auto",
        theme: "grid",
        startY:lastY+14,
        styles: { fontSize: 8 },
        headStyles: { fillColor: "#34495e" },
        body: item.data.map((item)=>Object.values(item)),
      });
    }else{
      
      autoTable(doc, { html: "#my-table" });
      doc.text(20,15,item.heading)
      autoTable(doc, {
        head: [item.header],
        font: "helvetica",
        tableWidth: "auto",
        startY: marginY,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: "#34495e" },
        body: item.data.map((item)=>Object.values(item)),
      });
    }

  })

  doc.save(filename.replace(/\s+/g, '_').trim() + ".pdf");

}


export function downloadPdfFile(filename,headerData,tabledata,multi){
 
  const doc = new jsPDF();
  var marginY = 20;
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(filename,20, 15);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal"); 
  autoTable(doc, { html: "#my-table" });
  autoTable(doc, {
    head: [headerData],
    font: "helvetica",
    tableWidth: "auto",
    // startY: marginY,
    theme: "grid",
    styles: { fontSize: 8 },
    didDrawPage: (data) => {
      var pageSize = doc.internal.getNumberOfPages();
      // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(`${String(data.pageNumber)}`, 100, 290);
    },
    headStyles: { fillColor: "#34495e" },
    columnStyles: {
      2: {
        cellWidth: 'auto'
      }
    },
    body: tabledata.map((item)=>Object.values(item)),
  });
  {
    multi &&
    // doc.text(filename,0,0);
    autoTable(doc, {
      head: [headerData],
      font: "helvetica",
      tableWidth: "auto",
      // startY: marginY,
      theme: "grid",
      styles: { fontSize: 8 },
      didDrawPage: (data) => {
        var pageSize = doc.internal.getNumberOfPages();
        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.text(`${String(data.pageNumber)}`, 100, 290);
      },
      headStyles: { fillColor: "#34495e" },
      body: tabledata.map((item)=>Object.values(item)),
    });
  }
  doc.setFontSize(10);
  doc.save(filename.replace(/\s+/g, '_').trim() + ".pdf");
}
export function convertDateYMD(inputFormat) {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
}

export function convertDateTime(inputDate) {
  const d = new Date(inputDate);
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var daTe = new Date(d);
  let time = daTe.toString().substr(16, 5);
  var H = +time.substr(0, 2);
  var h = H % 12 || 12;
  var ampm = H < 12 ? "AM" : "PM";
  time = h + time.substr(2, 3) + " " + ampm;
  return (
    [pad(daTe.getDate()), pad(daTe.getMonth() + 1), daTe.getFullYear()].join(
      "/"
    ) +
    " | " +
    time
  );
}

export function convertDateTimeChecklist(inputDate) {
  const d = new Date(inputDate);
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var daTe = new Date(d);
  let time = daTe.toString().substr(16, 5);
  var H = +time.substr(0, 2);
  var h = H % 12 || 12;
  var ampm = H < 12 ? "AM" : "PM";
  time = h + time.substr(2, 3) + " " + ampm;
  return (
    [pad(daTe.getDate()), pad(daTe.getMonth() + 1), daTe.getFullYear()].join(
      "/"
    ) +
    " " +
    time
  );
}

export const getFullName = (item) => {
  return item.LASTNAME !== " NULL"
    ? `${item?.FIRSTNAME} ${item?.LASTNAME}`
    : `${item?.FIRSTNAME}`;
};
export const getAddress = (item) => {
  return item.LOCALITY !== " NULL"
    ? `${item?.HNO} ${item?.LOCALITY}`
    : `${item?.HNO}`;
};
export const getRelationName = (item) => {
  return item === " NULL" ? `N.A` : `${item.toLowerCase()}`;
};

export function filterFunc(
  d,
  formtype,
  requesttype,
  formstatus,
  partno,
  fromdate,
  todate
) {
  if (formtype) {
    d = d.filter((a) => a.processMasterId == formtype);
  }
  if (requesttype) {
    d = d.filter((a) => a.requestValue == requesttype);
  }
  if (formstatus) {
    d = d.filter((a) => a.currentStatusId == formstatus);
  }
  if (partno) {
    d = d.filter((a) => a.partNumber == partno);
  }
  if (fromdate) {
    d = d.filter((a) => convertDateYMD(a.assignedDate) >= fromdate);
  }
  if (todate) {
    d = d.filter((a) => convertDateYMD(a.assignedDate) <= todate);
  }
  return d;
}

export function statuses(allStatuses, formcurrentstatus) {
  var statusD = [];
  for (let index = 0; index < allStatuses.length; index++) {
    statusD = statusD.concat(
      formcurrentstatus.data.filter(
        (a) => a.statusId == allStatuses[index].currentStatusId
      )
    );
  }
  return statusD;
}

export function convertDateMonth(inputFormat) {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  var d = new Date(inputFormat);
  var monthsData = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };
  return [
    pad(d.getDate()),
    monthsData[pad(d.getMonth() + 1)],
    d.getFullYear(),
  ].join(" ");
}

export function formatFrom24Hrsto12Hrs(timeString) {
  var hourEnd = timeString?.indexOf(":");
  var H = +timeString?.substr(0, hourEnd);
  var h = H % 12 || 12;
  var Hr = h < 10 ? "0" + h : h;
  var ampm = H < 12 || H === 24 ? "AM" : "PM";
  timeString = Hr + timeString?.substr(hourEnd, 3) + " " + ampm;
  return timeString;
}

export function getAge(birthDate) {
  var age = Math.floor(
    (new Date() - new Date(birthDate).getTime()) / 3.15576e10
  );
  return age;
}

export function ist(date) {
  var dt = new Date(date).toLocaleString(undefined, {
    timeZone: "Asia/Kolkata",
  });
  return dt;
}

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export function getNumberWithOrdinal(n) {
  var s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function monthName(n) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthNames[parseInt(n - 1)];
}
export function addTranslationScript() {
  const script = document.createElement("script");
  script.src = "/Packages/transliteration/js/CDAC-Typing.js";
  script.id = "translation";
  document.body.appendChild(script);
  const removeScript = () => {
    script.parentNode.removeChild(script);
  };
  return removeScript;
}
export const createPdf = (name, id, height = 1850) => {
  let width = window.screen.width;
  width =
    width > 1500
      ? width + 50
      : width > 1400
      ? width - 150
      : width > 1000
      ? width - 100
      : width - 50;

  const dom = document.querySelector(`#${id}`);
  html2canvas(dom, {
    scale: 1.2,
    onclone: (doc) => {},
  }).then((canvas) => {
    const img = canvas.toDataURL("image/jpeg");
    const pdf = new jsPDF("p", "pt", [height, width]);
    pdf.addImage(img, "JPEG", 40, 40);
    pdf.save(`${name}.pdf`);
  });
};
export const getCanvasData = (element) => {
  return new Promise((resolve, reject) => {
    //     const srcWidth=element.scrollWidth;
    //     const srcHeight=element.scrollHeight;
    // const imgRatio = imgWidth / imgHeight;

    html2canvas(element, { logging: true })
      .then(function (canvas) {
        resolve({ url: canvas.toDataURL("image/jpeg", 1.0), canvas });
      })
      .catch(function (error) {
        reject(
          "Error while creating canvas for element with ID: " + element.id
        );
      });
  });
};

export const promisePrint = (name, id1, id2, height, width) => {
  // let width = window.screen.width;
  // width =
  //   width > 1500
  //     ? width + 50
  //     : width > 1400
  //       ? width - 150
  //       : width > 1000
  //         ? width - 100
  //         : width - 50;
  var pdf = new jsPDF("p", "pt", "a4");
  // const pageWidth = pdf.internal.pageSize.getWidth();
  // const pageHeight = pdf.internal.pageSize.getHeight();
  // const pageRatio = pageWidth / pageHeight;
  let pageIds = [id1, id2];
  let promises = [];
  pageIds.forEach((page) => {
    promises.push(getCanvasData(document.getElementById(page)));
  });
  Promise.all(promises).then((dataUrls) => {
    dataUrls.forEach((dataUrl, i) => {
      pdf.addImage(dataUrl.url, "JPEG", 10, 10, 575, 820, "", "NONE");
      if (i < pageIds.length - 1) {
        pdf.addPage();
      }
    });
    pdf.save(`${name}.pdf`);
  });
};

export const promiseSinglePrint = (name, id1, height, width) => {
  var pdf = new jsPDF("p", "pt", "a4");
  let pageIds = [id1];
  let promises = [];
  pageIds.forEach((page) => {
    promises.push(getCanvasData(document.getElementById(page)));
  });
  Promise.all(promises).then((dataUrls) => {
    dataUrls.forEach((dataUrl, i) => {
      pdf.addImage(dataUrl.url, "JPEG", 10, 10, 575, 820, "", "NONE");
      if (i < pageIds.length - 1) {
        pdf.addPage();
      }
    });
    pdf.save(`${name}.pdf`);
  });
};

export const downloadFile = function (fileName) {
  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.access_token,
      currentRole: localStorage.userrole,
      appName: "ETPBMS",
      atkn_bnd: localStorage?.atkn_bnd,
      rtkn_bnd: localStorage?.rtkn_bnd,
      channelidobo: "ETPBMS",  
      "PLATFORM-TYPE":PLATFORM_TYPE  
    },
  };

  axios
    .get(
      BASE_URLS.OBJECTSTORE_BASE_URL +
        `api/v1/document/getFile?bucketName=objectstorage&fileName=${fileName}`,
      header
    )
    .then((data) => {
      if (data) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        let fileExt = data.data.refId
          .split(".")
          [data.data.refId.split(".").length - 1]?.toLowerCase();
        const format = fileExt === ".pdf" ? "application/pdf" : "image/*";
        a.href = `data:${format};base64,` + data.data.file;
        a.download = fileName;
        a.click();
        document.body.removeChild(a);
      }
    })
    .catch((err) => console.log("ERROR TO DOWNLOAD", err));
};


export const disabledTransliteration = (elementId) => {
  const ele = document.querySelector(`#${elementId}`);
  const event1 = new Event("focus");
  ele.dispatchEvent(event1);
  const event = new Event("blur");
  ele.dispatchEvent(event);
};

export const isTokenExpired = (exp) => {
  return exp <= Math.floor(new Date().getTime() / 1000);
};

export const levenshteinDistance=(s1, s2)=>{
  const len1 = s1.length;
  const len2 = s2.length;
  const matrix = [];

  for (let i = 0; i <= len1; i++) {
      matrix[i] = [i];
  }

  for (let j = 0; j <= len2; j++) {
      matrix[0][j] = j;
  }

  for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
          if (s1[i - 1] === s2[j - 1]) {
              matrix[i][j] = matrix[i - 1][j - 1];
          } else {
              matrix[i][j] = Math.min(
                  matrix[i - 1][j - 1] + 1, // substitution
                  matrix[i][j - 1] + 1,     // insertion
                  matrix[i - 1][j] + 1      // deletion
              );
          }
      }
  }

  return matrix[len1][len2];
}

export const calculateMatchPercentage=(str1, str2)=>{
  const maxLen = Math.max(str1.length, str2.length);
  const distance = levenshteinDistance(str1, str2);
  const matchPercentage = ((maxLen - distance) / maxLen) * 100;
  return matchPercentage;
}

export const matchStrings = (str1, str2, thresholdLow = 80, thresholdHigh= 100)=>{
  const matchPercentage = calculateMatchPercentage(str1, str2);

  if (matchPercentage >= thresholdLow && matchPercentage < thresholdHigh ) {
      return false;
  } else {
      return true;
  }
}

export const isValidFileNameFormC=(input,fileName1, filename2)=>{
 
  if(input.length < 30){
    return false ;
  }

  const allowedChars = new Set(["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","0","1","2","3","4","5","6","7","8","9",0,1,2,3,4,5,6,7,8,9,"a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"," ",".","-","#",","]);
 
  var hashCount = 0;

  for (let char of input) {
    if (!allowedChars.has(char)) {
      return false;
    }
    if(char == "#"){
      hashCount ++
    }
  }
 
  if(hashCount !==7){
    return false ;
  }

  

  return true;
   
  // Check if there is a space immediately after #
  // for (let i = 0; i < input.length - 1; i++) {
  //   if (input[i] === '#' && input[i + 1] === ' ') {
  //     return false;
  //   }
  // }
}

export const isValidFileNameFormARight=(input,fileNamedb)=>{

  if(input.length < 30){
    return false ;
  }

  const allowedChars = new Set(["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","0","1","2","3","4","5","6","7","8","9",0,1,2,3,4,5,6,7,8,9,"a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"," ",".","-","#",","]);
 
  var hashCount = 0;

  for (let char of input) {
    if (!allowedChars.has(char)) {
      return false;
    }
    if(char == "#"){
      hashCount ++
    }
  }
 
  if(hashCount !==7){
    return false ;
  }

  return matchStrings(input,fileNamedb, 80 , 100);
   
  // Check if there is a space immediately after #
  // for (let i = 0; i < input.length - 1; i++) {
  //   if (input[i] === '#' && input[i + 1] === ' ') {
  //     return false;
  //   }
  // }
}

export const isValidFileNameFormBandFormAleft=(input,epbIddb)=>{

  if(input.length !== 16){
    return false ;
  }

  const allowedChars = new Set(["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","0","1","2","3","4","5","6","7","8","9",0,1,2,3,4,5,6,7,8,9,"a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"]);
 

  for (let char of input) {
    if (!allowedChars.has(char)) {
      return false;
    }
  }
 
  return matchStrings(input, epbIddb, 80 , 100);
   
}

export const removeCookie = (name) => {
  const isLocalhost = window.location.hostname === 'localhost';
  const isHttps = window.location.protocol === 'https:';
    const appName = window.location.hostname
    let updatedKey = name;

    if(appName.includes('demo')){
      updatedKey = `${name}STG`;
    }

  let cookieStr = `${updatedKey}=; Max-Age=0; path=/`;
 
  if (!isLocalhost) {
cookieStr += '; domain=.eci.gov.in';
  }
 
  if (isHttps) {
    cookieStr += '; Secure; SameSite=Lax';
  }
 
  document.cookie = cookieStr;
};

export function triggerRefreshTokenApi(api) {
  if (localStorage.getItem("refreshToken")) {
    axios
      .post(
        BASE_URLS.LOGIN_BASE_URL + "api/v1/authn-sso/refresh",
        {
          applicationName:
            localStorage.userrole == "nodal" ||
            localStorage.userrole == "record" ||
            localStorage.userrole == "unit"
              ? USERTYPE.SVP
              : USERTYPE.ERONET,
          refreshToken: localStorage.getItem("refreshToken"),
        },
        {
          withCredentials:true,
          headers: {
            "Content-Type": "application/json",
            atkn_bnd: localStorage?.atkn_bnd,
            rtkn_bnd: localStorage?.rtkn_bnd,
            channelidobo: "SVP",
            "PLATFORM-TYPE":PLATFORM_TYPE
          },
        }
      )
      .then((result) => {
        if (result && result.data && result.data.access_token) {
          localStorage.setItem("access_token", result.data?.access_token);
          localStorage.setItem("refreshToken", result.data?.refresh_token);
          localStorage.setItem("rtkn_bnd", result.data?.rtkn_bnd);
          localStorage.setItem("atkn_bnd", result.data?.atkn_bnd);
          // window.location.reload()
        } else {
          localStorage.clear()
          setTimeout(() => {
            localStorage.clear();
            window.location = "/login";
          }, 2000);

        }
      })
      .catch((err) => {
        localStorage.clear()
        setTimeout(() => {
          localStorage.clear();
          window.location = "/login";
        }, 2000);

      });
  }
}